export interface Faq {
  question: string
  answer: string
}

export const faqs: Faq[] = [
  {
    question: 'Devo essere un’artista per usare ARTE PRONTA™?',
    answer:
      'No. Ogni volume è pensato anche per chi non ha una formazione artistica specifica, con spiegazioni chiare e materiali pronti passo-passo.',
  },
  {
    question: 'Per quali classi è adatto?',
    answer:
      'Per tutte le classi dalla 1ª Primaria alla 3ª Media (età 6-14 anni): un volume dedicato a ogni anno scolastico.',
  },
  {
    question: 'Ricevo un file fisico o digitale?',
    answer:
      'Digitale: ricevi i file PDF pronti da stampare o da usare direttamente su schermo, con accesso immediato dopo l’acquisto.',
  },
  {
    question: 'Segue la progressione della materia Arte e Immagine?',
    answer:
      'Sì. I contenuti seguono una progressione pensata per la materia Arte e Immagine: dal linguaggio visivo e le prime tecniche alla Primaria, fino alla storia dell’arte e alla preparazione al colloquio d’esame in Terza Media.',
  },
  {
    question: 'Posso usarlo anche a casa con mio figlio?',
    answer: 'Sì, molte famiglie lo usano anche per attività pomeridiane o come supporto allo studio a casa.',
  },
  {
    question: 'Cosa succede se non mi piace?',
    answer: 'Hai 30 giorni per chiedere il rimborso completo, senza bisogno di spiegazioni.',
  },
]
